function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { usePersistFn } from "./usePersistFn";
var trackFn = function trackFn(result) {
  var key = result.key,
    data = result.data,
    platform = result.platform;
  if (platform === "ga") {
    // PionexReportV2.trackingEvent({
    //     category: key,
    //     action: JSON.stringify(data),
    // });
  } else {
    // Mixpanel.trackEvent(key, data);
  }
};
export var setTrackFn = function setTrackFn(fn) {
  trackFn = fn;
};
export var TrackPlatform;
(function (TrackPlatform) {
  TrackPlatform["mixpanel"] = "mixpanel";
  TrackPlatform["ga"] = "ga";
})(TrackPlatform || (TrackPlatform = {}));
// TODO: 支持异步
var getParams = function getParams(params) {
  var key, data, platform, result;
  if (typeof params === "function") {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    result = params.apply(void 0, rest);
    if (!result) {
      return;
    }
  } else {
    result = params;
  }
  if (_typeof(result) === "object") {
    key = result.key;
    data = result.data || {};
    platform = result.platform || "ga";
  } else {
    key = result;
    data = {};
    platform = "ga";
  }
  return {
    key: key,
    data: data,
    platform: platform
  };
};
export function useTrackFn(params) {
  return usePersistFn(function () {
    for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      rest[_key2] = arguments[_key2];
    }
    var result = getParams.apply(void 0, [params].concat(rest));
    if (result) {
      trackFn(result);
      return true;
    }
    return false;
  });
}